import getLocale from '@billogram/get-locale';


export default function getNumberSeparators(): { decimal: RegExp; thousand: RegExp; } {
    const locale = getLocale();
    switch (locale) {
        case 'de':
            return {
                decimal: /,/,
                thousand: /./,
            };

        case 'en':
            return {
                decimal: /./,
                thousand: /,/,
            };

        case 'sv':
            return {
                decimal: /,/,
                thousand: /\s/,
            };

        default:
            throw new Error(`Missing separators for locale \`${locale}\`.`);
    }
}
